export const actionTypes: any = {
  // get
  GET_ALL_LEAD_NATURE_START: 'GET_ALL_LEAD_NATURE_START',
  GET_ALL_LEAD_NATURE_SUCCESS: 'GET_ALL_LEAD_NATURE_SUCCESS',
  GET_ALL_LEAD_NATURE_FINISH: 'GET_ALL_LEAD_NATURE_FINISH',

  // extended hours
  GET_LEAD_NATURE_START: 'GET_LEAD_NATURE_START',
  GET_LEAD_NATURE_SUCCESS: 'GET_LEAD_NATURE_SUCCESS',
  GET_LEAD_NATURE_FINISH: 'GET_LEAD_NATURE_FINISH',

  // add branch
  ADD_LEAD_NATURE_START: 'ADD_LEAD_NATURE_START',
  ADD_LEAD_NATURE_SUCCESS: 'ADD_LEAD_NATURE_SUCCESS',
  ADD_LEAD_NATURE_FINISH: 'ADD_LEAD_NATURE_FINISH',
  RESET_LEAD_NATURE: 'RESET_LEAD_NATURE',

  // update LEAD_NATURE
  UPDATE_LEAD_NATURE_START: 'UPDATE_LEAD_NATURE_START',
  UPDATE_LEAD_NATURE_SUCCESS: 'UPDATE_LEAD_NATURE_SUCCESS',
  UPDATE_LEAD_NATURE_FINISH: 'UPDATE_LEAD_NATURE_FINISH',

  // delete LEAD_NATURE
  DELETE_LEAD_NATURE_START: 'DELETE_LEAD_NATURE_START',
  DELETE_LEAD_NATURE_SUCCESS: 'DELETE_LEAD_NATURE_SUCCESS',
  DELETE_LEAD_NATURE_FINISH: 'DELETE_LEAD_NATURE_FINISH',

  // Enable LEAD_NATURE
  ENABLE_LEAD_NATURE_REQUEST: 'ENABLE_LEAD_NATURE_REQUEST',
  ENABLE_LEAD_NATURE_SUCCESS: 'ENABLE_LEAD_NATURE_SUCCESS',
  ENABLE_LEAD_NATURE_FINISH: 'ENABLE_LEAD_NATURE_FINISH',

  // Disable LEAD_NATURE
  DISABLE_LEAD_NATURE_REQUEST: 'DISABLE_LEAD_NATURE_REQUEST',
  DISABLE_LEAD_NATURE_SUCCESS: 'DISABLE_LEAD_NATURE_SUCCESS',
  DISABLE_LEAD_NATURE_FINISH: 'DISABLE_LEAD_NATURE_FINISH',

  // Enable LEAD_NATURE
  SINGLE_ENABLE_LEAD_NATURE_REQUEST: 'SINGLE_ENABLE_LEAD_NATURE_REQUEST',
  SINGLE_ENABLE_LEAD_NATURE_SUCCESS: 'SINGLE_ENABLE_LEAD_NATURE_SUCCESS',
  SINGLE_ENABLE_LEAD_NATURE_FINISH: 'SINGLE_ENABLE_LEAD_NATURE_FINISH',

  // Disable LEAD_NATURE
  SINGLE_DISABLE_LEAD_NATURE_REQUEST: 'SINGLE_DISABLE_LEAD_NATURE_REQUEST',
  SINGLE_DISABLE_LEAD_NATURE_SUCCESS: 'SINGLE_DISABLE_LEAD_NATURE_SUCCESS',
  SINGLE_DISABLE_LEAD_NATURE_FINISH: 'SINGLE_DISABLE_LEAD_NATURE_FINISH',
}

